import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AdminRoutingModule } from './admin-routing.module';
import { SharedModule } from '../shared/shared.module';

import { AdminHeaderComponent } from './components/admin-header/admin-header.component';
import { AdminRootComponent } from './admin-root.component';
import { AdminLandingComponent } from './pages/admin-landing/admin-landing.component';
import { AdminSiteComponent } from './pages/admin-site/admin-site.component';
import { AdminUserComponent } from './pages/admin-user/admin-user.component';
import { AdminUserDetailComponent } from './pages/admin-user-detail/admin-user-detail.component';
import { AdSearchComponent } from './components/ad-search/ad-search.component';
import { AdminSiteDetailComponent } from './pages/admin-site-detail/admin-site-detail.component';
import { CameraEditorComponent } from './components/camera-editor/camera-editor.component';
import { AdminAlertComponent } from './pages/admin-alert/admin-alert.component';
import { AdminAlertDetailComponent } from './pages/admin-alert-detail/admin-alert-detail.component';
import { UserPickerComponent } from './components/user-picker/user-picker.component';
import { SitePickerComponent } from './components/site-picker/site-picker.component';
import { AdminInventoryComponent } from './pages/admin-inventory/admin-inventory.component';
import { ActionAlertHelpComponent } from './pages/action-alert-help/action-alert-help.component';

@NgModule({
  declarations: [
    AdminHeaderComponent,
    AdminRootComponent,
    AdminLandingComponent,
    AdminSiteComponent,
    AdminUserComponent,
    AdminUserDetailComponent,
    AdSearchComponent,
    AdminSiteDetailComponent,
    CameraEditorComponent,
    AdminAlertComponent,
    AdminAlertDetailComponent,
    UserPickerComponent,
    SitePickerComponent,
    AdminInventoryComponent,
    ActionAlertHelpComponent
  ],
  imports: [
    SharedModule,
    CommonModule,
    NgbModule,
    AdminRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgOptimizedImage
  ],
})
export class AdminModule { }
